'use es6';

// TODO fix this (for Map)
import { TOP, BOTTOM, LEFT, RIGHT } from '../constants';
import { hoverTypes, LAYOUT_SECTION_OUTER_BUFFER_SIZE } from '../constants/dndAreaHoverPositionConstants';
import { isPositionWithinBounds, isPositionWithinHorizontalBounds, isPositionWithinVerticalBounds } from '../geometry/basic';
export const getLayoutTreeChildrenMaps = nodePositions => {
  const mapOfPositionsById = new Map(nodePositions.map(node => [node.id, node]));
  const mapOfChildrenById = new Map();
  nodePositions.forEach(node => {
    if (!mapOfChildrenById.has(node.parentId)) {
      mapOfChildrenById.set(node.parentId, []);
    }
    mapOfChildrenById.get(node.parentId).push(node.id);
  });
  return {
    mapOfPositionsById,
    mapOfChildrenById
  };
};
export const areColumnsInRow = (previousColumn, currentNodeToCheck) => {
  return previousColumn && previousColumn.parentId && previousColumn.parentId === currentNodeToCheck.parentId;
};
export const areRowsInColumn = (previousRow, currentNodeToCheck) => {
  return previousRow && previousRow.parentId && previousRow.parentId === currentNodeToCheck.parentId;
};
export const isTopLevelSectionRow = node => {
  return node.depth === 1;
};
export const isFirstTopLevelSectionRow = node => {
  return isTopLevelSectionRow(node) && !node.previousRowId;
};
export const isLastTopLevelSectionRow = node => {
  return isTopLevelSectionRow(node) && !node.nextRowId;
};
export const getChildrenForCurrentNode = (currentNodeId, mapOfChildrenById, mapOfPositionsById) => {
  const childrenIdsForCurrentNode = mapOfChildrenById.get(currentNodeId) || [];
  return childrenIdsForCurrentNode.map(nodeId => {
    return mapOfPositionsById.get(nodeId);
  });
};
export const getFirstChildOfNode = (currentNode, mapOfChildrenById, mapOfPositionsById) => {
  const childrenIds = mapOfChildrenById.get(currentNode.id) || [];
  return mapOfPositionsById.get(childrenIds[0]);
};
export const getLastChildOfNode = (currentNode, mapOfChildrenById, mapOfPositionsById) => {
  const childrenIds = mapOfChildrenById.get(currentNode.id) || [];
  return mapOfPositionsById.get(childrenIds[childrenIds.length - 1]);
};
export const isBetweenTwoColumns = (adjustedMouseCoords, currentNodeToCheck, previousColumn, mapOfPositionsById) => {
  const parentRowNode = mapOfPositionsById.get(currentNodeToCheck.parentId);
  return isPositionWithinBounds(adjustedMouseCoords, {
    top: parentRowNode.top,
    bottom: parentRowNode.bottom,
    left: previousColumn.right,
    right: currentNodeToCheck.left
  });
};
export const isBetweenTwoRows = (adjustedMouseCoords, currentNodeToCheck, previousRow, mapOfPositionsById) => {
  const parentColumn = mapOfPositionsById.get(currentNodeToCheck.parentId);
  return isPositionWithinBounds(adjustedMouseCoords, {
    top: previousRow.bottom,
    bottom: currentNodeToCheck.top,
    left: parentColumn.left,
    right: parentColumn.right
  });
};
export const calculateOutsideLayoutTreeBufferAreaHoverPositions = ({
  adjustedMouseCoords,
  mapOfPositionsById,
  mapOfChildrenById,
  closestLayoutTreeId,
  relativeLocation
}) => {
  const insertInfo = {};
  if (closestLayoutTreeId && relativeLocation) {
    // Get all the immediate children of this layout section
    const childrenById = mapOfChildrenById.get(closestLayoutTreeId);
    if (childrenById) {
      // If the mouse was above layout section, get the top most row id, we want to insert a new row before it
      if (relativeLocation === TOP) {
        const topRowId = childrenById[0];
        const topRowNode = mapOfPositionsById.get(topRowId);
        insertInfo.id = topRowId;
        insertInfo.isColumn = topRowNode.isColumn;
        insertInfo.parentId = closestLayoutTreeId;
        insertInfo.previousRowId = topRowNode.previousRowId;

        // If the mouse was below the layout section, get the bottom most row id, we want to insert a new row after it
      } else if (relativeLocation === BOTTOM) {
        const bottomRowId = childrenById[childrenById.length - 1];
        const bottomRowNode = mapOfPositionsById.get(bottomRowId);
        insertInfo.id = bottomRowId;
        insertInfo.isColumn = bottomRowNode.isColumn;
        insertInfo.parentId = closestLayoutTreeId;
        insertInfo.nextRowId = bottomRowNode.nextRowId;

        // If the mouse is to the left or right of the layout section, figure out which child row it is closest to
      } else if (relativeLocation === LEFT || relativeLocation === RIGHT) {
        let childRowNodeToLeftOrRightOfMouse;
        for (const childId of childrenById) {
          const childRowNode = mapOfPositionsById.get(childId);
          if (isPositionWithinVerticalBounds(adjustedMouseCoords, childRowNode)) {
            childRowNodeToLeftOrRightOfMouse = childRowNode;
            break;
          }
        }
        if (childRowNodeToLeftOrRightOfMouse) {
          // Get all the children columns of this row
          const childColumnsOfThisRow = getChildrenForCurrentNode(childRowNodeToLeftOrRightOfMouse.id, mapOfChildrenById, mapOfPositionsById);
          if (childColumnsOfThisRow.length > 0) {
            // If the mouse is on the left side of the layout section, grab the left most
            // column in this row, and use it's id's info for the hover positions
            if (relativeLocation === LEFT) {
              const leftMostNodeInRow = childColumnsOfThisRow[0];
              insertInfo.id = leftMostNodeInRow.id;
              insertInfo.parentId = leftMostNodeInRow.parentId;
              insertInfo.previousColumnId = leftMostNodeInRow.previousColumnId;
              // If the mouse is on the right side of the layout section, grab the right most
              // column in this row, and use it's id's info for the hover positions
            } else if (relativeLocation === RIGHT) {
              const rightMostNodeInRow = childColumnsOfThisRow[childColumnsOfThisRow.length - 1];
              insertInfo.id = rightMostNodeInRow.id;
              insertInfo.parentId = rightMostNodeInRow.parentId;
              insertInfo.nextColumnId = rightMostNodeInRow.nextColumnId;
            }
          }
        }
      }
    }

    // Only push things onto the hover stack if we calculated a suitable drop target
    if (insertInfo.id) {
      // Push the actual hover position onto the stack. The mouse isn't actually
      // over this node, but we'll pretend it is for drop targets sake.
      return Object.assign({
        layoutSectionId: closestLayoutTreeId,
        //TODO remove layoutSection in favor of layoutTree
        layoutTreeId: closestLayoutTreeId,
        type: hoverTypes.OUTSIDE_LAYOUT_SECTION,
        relativeLocation
      }, insertInfo);
    }
  }
  return null;
};

// Find the closest layout section when we are NOT hovered directly over any of them
export const getClosestDndArea = (nodePositions, adjustedMouseCoords, initialClosestDistance = LAYOUT_SECTION_OUTER_BUFFER_SIZE) => {
  let closestLayoutTreeId;
  let relativeLocation;
  let closestDistance = initialClosestDistance;
  nodePositions.forEach(nodePos => {
    if (nodePos.depth === 0) {
      if (isPositionWithinVerticalBounds(adjustedMouseCoords, nodePos)) {
        const isRightOfNode = adjustedMouseCoords.x - nodePos.left > 0;
        const dist = Math.abs(adjustedMouseCoords.x - (isRightOfNode ? nodePos.right : nodePos.left));
        if (dist < closestDistance) {
          closestDistance = dist;
          closestLayoutTreeId = nodePos.id;
          relativeLocation = isRightOfNode ? RIGHT : LEFT;
        }
      } else if (isPositionWithinHorizontalBounds(adjustedMouseCoords, nodePos)) {
        const isBottomOfNode = adjustedMouseCoords.y - nodePos.top > 0;
        const dist = Math.abs(adjustedMouseCoords.y - (isBottomOfNode ? nodePos.bottom : nodePos.top));
        if (dist < closestDistance) {
          closestDistance = dist;
          closestLayoutTreeId = nodePos.id;
          relativeLocation = isBottomOfNode ? BOTTOM : TOP;
        }
      }
    }
  });
  return {
    closestLayoutTreeId,
    relativeLocation
  };
};
export const getDeepestHoveredNode = (nodesToCheck, mapOfChildrenById, mapOfPositionsById, adjustedMouseCoords) => {
  const stack = [];
  nodesToCheck = nodesToCheck.slice(0);
  while (nodesToCheck.length > 0) {
    const currentNodeToCheck = nodesToCheck.shift();
    if (isPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck)) {
      const children = getChildrenForCurrentNode(currentNodeToCheck.id, mapOfChildrenById, mapOfPositionsById);
      stack.push(currentNodeToCheck);
      nodesToCheck.push(...children);
    }
  }
  return stack[stack.length - 1];
};